import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import { UtilsService } from '../../services/UtilsService';
import { setOptions, importLibrary } from '@googlemaps/js-api-loader';
import { HttpRequestService } from '../../services/HttpRequestService';
import { MarkerClusterer } from "@googlemaps/markerclusterer";
const API_KEY = 'AIzaSyCdUt6i3B7uVKt2xebfwPdIQAnn11mlf7M';


class AccountsMap extends Component {

    constructor(props) {
        super(props);
        this.utils = new UtilsService();
        this.http = new HttpRequestService();
        this.mapReady = new Promise((resolve) => { this.mapLoaded = resolve; });
        this.setState({
            specialties: null,
            fieldRepManaged: null,
        });
        this.markerClusterer = null;
        this.filterBtns = [];
    }

    componentDidMount() {
        this.initMap();
        this.getAccounts();
        window.refreshLocation = (addressId) => this.refreshLocation(addressId);
    }

    componentWillUnmount() {
        delete window.refreshLocation;
    }

    async refreshLocation(addressId) {
        try {
            await this.http.get(`/api/CRM/RefreshAccountLocation`, { id: addressId });
            this.getAccounts(this.state.specialties, this.state.fieldRepManaged);
        } catch (e) {
            this.utils.alert('Failed to refresh location.');
        }
    }

    async getAccounts(specialties = null, fieldRepManaged = null) {
        this.filterBtns.forEach(b => b.disabled = true);
        try {
        if (this.markerClusterer) {
            this.markerClusterer.clearMarkers();
        }

        const params = {
            specialties: specialties,
            fieldRepManaged: fieldRepManaged
        };

        this.setState({ specialties: specialties, fieldRepManaged: fieldRepManaged });
        const [data, map] = await Promise.all([
            this.http.get('/api/CRM/GetFieldRepAccountLocations', params),
            this.mapReady
        ]);

        const { AdvancedMarkerElement, PinElement } = await importLibrary("marker");
        const infoWindow = new window.google.maps.InfoWindow({
            content: "",
            disableAutoPan: true,
        });

        // Group accounts that share the exact same coordinates into one marker
        const locations = new Map();
        for (const account of data) {
            const key = `${account.latitude},${account.longitude}`;
            if (!locations.has(key)) {
                locations.set(key, []);
            }
            locations.get(key).push(account);
        }

        const markers = Array.from(locations.values()).map(accounts => {
            const { latitude, longitude } = accounts[0];
            const pinGlyph = new PinElement({
                glyph: accounts.length > 1 ? String(accounts.length) : "",
                glyphColor: "white",
            });

            const marker = new AdvancedMarkerElement({
                position: { lat: latitude, lng: longitude },
                content: pinGlyph.element
            });

            marker.addListener("click", () => {
                const mapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}`;
                const accountsHtml = accounts.map(a => {
                    const addressLine2 = a.address2 ? `<div>${a.address2}</div>` : '';
                    return `
                        <div style="padding:6px 0;${accounts.length > 1 ? 'border-bottom:1px solid #eee;' : ''}">
                            <div><strong>${a.companyName}</strong></div>
                            <div style="margin-bottom:2px"><a target="_blank" href="/app/crm/account/${a.accountId}">#${a.accountNumber}</a></div>
                            <div>${a.contactName}</div>
                            <div>${a.address1}</div>
                            ${addressLine2}
                            <div>${a.city}, ${a.zip}</div>
                            <div style="margin-top:4px">
                                <button class="btn btn-link" style="font-size:0.7rem;padding:0" onclick="window.refreshLocation(${a.addressId})">
                                    <i class="fas fa-sync-alt"></i> Fix Location
                                </button>
                            </div>
                        </div>`;
                }).join('');
                infoWindow.setContent(`
                    <div class="map-info-window">
                        ${accountsHtml}
                        <div style="display:flex;justify-content:space-between;align-items:center;margin-top:8px">
                            <a href="${mapsUrl}" target="_blank" rel="noopener noreferrer" class="btn btn-info">
                                <i class="fas fa-directions"></i> Directions
                            </a>
                        </div>
                    </div>
                `);
                infoWindow.open(map, marker);
            });
            return marker;
        });
        this.markerClusterer = new MarkerClusterer({ markers, map });
        } finally {
            this.filterBtns.forEach(b => b.disabled = false);
        }
    }

    async initMap() {
        // Set loader options.
        setOptions({
            key: API_KEY,
            v: 'weekly',
        });

        const { Map } = (await importLibrary('maps'));
        const { ControlPosition } = window.google.maps;
        const defaultLocation = { lat: 38.60658974410338, lng: -90.27541380977887 }

        // Resolve the initial center from geolocation
        const center = await new Promise((resolve) => {
            if (!navigator.geolocation) {
                resolve(defaultLocation);
                return;
            }
            navigator.geolocation.getCurrentPosition(
                (position) => resolve({ lat: position.coords.latitude, lng: position.coords.longitude }),
                () => resolve(defaultLocation)
            );
        });

        // Declare the map.
        const map = new Map(document.getElementById('map'), {
            center, zoom: 10,
            mapId: 'accounts-map',
            cameraControl: false,
            mapTypeControl: true,
            scaleControl: true,
            streetViewControl: true,
            rotateControl: false,
            fullscreenControl: true
        });

        // Add a "Current Location" button control.
        const locationButton = document.createElement('button');
        locationButton.title = 'Show my location';
        locationButton.className = 'map-location-btn';
        locationButton.innerHTML = '<i class="fas fa-crosshairs"></i>';
        locationButton.addEventListener('click', () => {
            if (!navigator.geolocation) {
                this.utils.alert('Geolocation is not supported by your browser.');
                return;
            }
            locationButton.classList.add('loading');
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const pos = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude,
                    };
                    map.setCenter(pos);
                    map.setZoom(12);
                    locationButton.classList.remove('loading');
                },
                () => {
                    this.utils.alert('Unable to retrieve your location.');
                    locationButton.classList.remove('loading');
                }
            );
        });
        map.controls[ControlPosition.RIGHT_BOTTOM].push(locationButton);

        // Specialty filter button group.
        const specialtyFilterGroup = document.createElement('div');
        specialtyFilterGroup.className = 'map-filter-group';

        const specialtyFilterButtons = [
            { label: 'All', specialty: null, specialtyIds: "" },
            { label: 'Dental', specialty: 'dental', specialtyIds: "54,55" },
            { label: 'Pediatric', specialty: 'pediatric', specialtyIds: "74" },
        ];

        const btnEls = specialtyFilterButtons.map(({ label, specialty, specialtyIds }) => {
            const btn = document.createElement('button');
            btn.textContent = label;
            btn.className = 'map-filter-btn' + (specialty === null ? ' active' : '');
            btn.addEventListener('click', () => {
                btnEls.forEach(b => b.classList.remove('active'));
                btn.classList.add('active');
                this.getAccounts(specialtyIds, this.state.fieldRepManaged);
            });
            specialtyFilterGroup.appendChild(btn);
            return btn;
        });
        this.filterBtns.push(...btnEls);

        map.controls[ControlPosition.TOP_CENTER].push(specialtyFilterGroup);

        // Field rep managed filter button group.
        const fieldRepManagedFilterGroup = document.createElement('div');
        fieldRepManagedFilterGroup.className = 'map-filter-group';

        const fieldRepManagedFilterButtons = [
            { label: 'All', value: null },
            { label: 'Field Rep Managed', value: true },
        ];

        const repBtnEls = fieldRepManagedFilterButtons.map(({ label, value }) => {
            const btn = document.createElement('button');
            btn.textContent = label;
            btn.className = 'map-filter-btn' + (value === null ? ' active' : '');
            btn.addEventListener('click', () => {
                repBtnEls.forEach(b => b.classList.remove('active'));
                btn.classList.add('active');
                this.getAccounts(this.state.specialties, value);
            });
            fieldRepManagedFilterGroup.appendChild(btn);
            return btn;
        });
        this.filterBtns.push(...repBtnEls);

        map.controls[ControlPosition.TOP_CENTER].push(fieldRepManagedFilterGroup);

        this.mapLoaded(map);
    }

    render() {
        return (
            <div className="page-inner">
                <div className="row">
                    <div className="col-md-12">
                        <div id="map" style={{ height: "calc(100vh - 100px)" }}></div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(AccountsMap);
